module.exports = __webpack_public_path__ + "static/media/logo-gd.90183c69.png";